import { LoadingSpinnerPanel } from '@frontend/web-react/components/Primitives/Loading/LoadingSpinnerPanel';
import { createFileRoute } from '@frontend/web/utils/router';
import { lazy, Suspense } from 'react';

const LazyPreviewTask = lazy(() =>
  import('./-id').then(({ PreviewTaskWithProviders }) => ({ default: PreviewTaskWithProviders })),
);

const PreviewRouteComponent = () => (
  <Suspense fallback={<LoadingSpinnerPanel fullScreen />}>
    <LazyPreviewTask />
  </Suspense>
);

export const Route = createFileRoute('/preview/$id')({
  component: PreviewRouteComponent,
});
